export default __webpack_public_path__ + "static/media/Print-481.a57ec265.jpg";